/* eslint-disable import/prefer-default-export */
export const reportQueryKeys = {
  reportListing: (filter: string) => ["report-list", filter],
};
